function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGmail = function SvgGmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 74.6 56"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.1 56H17V27.2L0 14.4v36.5C0 53.7 2.3 56 5.1 56",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7 56h11.9c2.8 0 5.1-2.3 5.1-5.1V14.4l-17 12.7",
    style: {
      fill: "#34a853"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7 5.1v22.1l17-12.7V7.6c0-6.3-7.2-9.9-12.2-6.1",
    style: {
      fill: "#fbbc04"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 27.2V5.1l20.4 15.3L57.7 5.1v22.1L37.3 42.4",
    style: {
      fill: "#ea4335"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.6v6.8l17 12.7v-22l-4.8-3.6C7.2-2.2 0 1.4 0 7.6",
    style: {
      fill: "#c5221f"
    }
  }));
};
export default SvgGmail;